import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

export class UpdateOrderDto {
  @Expose()
  code: string;

  @Expose()
  purchaseRequest?: string;

  @Expose()
  @Transform(({ value }) => toCents(value))
  quantity?: number;
}
